import { Icon, IconProps } from "./Icon";

export function IconVacuum(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M20.56 20H17l-1.7-2.63a3.7 3.7 0 0 0 .48.06 3 3 0 0 0 2.51-4.63l-6-9.24A3 3 0 0 0 9.75 2.2a3 3 0 0 0-2.64 1.56 3.25 3.25 0 0 0-.24.63L4 0H0v1h3.48l3.73 5.76v.07l3.32 5.11 5.37 8.29a3.7 3.7 0 0 0-1 .62A2.41 2.41 0 1 0 12.4 24H24v-.5a3.58 3.58 0 0 0-3.44-3.5ZM8 4.24a2 2 0 0 1 3.43-.13l6 9.23a2 2 0 0 1-1.67 3.09 2 2 0 0 1-1.67-.91l-1.28-2L8 6.16a2 2 0 0 1 0-1.92Zm3.24 17.34A1.42 1.42 0 1 1 12.65 23a1.43 1.43 0 0 1-1.42-1.42Zm3.5 1.42a2.66 2.66 0 0 1 2.38-2h3.44a2.66 2.66 0 0 1 2.38 2Z" />
    </Icon>
  );
}
